import React from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
} from 'semantic-ui-react';

const ContractLinkButton = (props) => {
  let editable = true;

  if (
    props.status === '1' ||
    props.status === '2' ||
    props.status === '3' ||
    props.status === '6'
  ) {
    editable = false;
  }

  return (
    <Button
      to={{ pathname: `/dealer/contracts/${props.id}`, state: { editable }}}
      as={Link}
      size="mini"
      icon="eye"
      color={props.color}
      basic
    />
  );
};

export default ContractLinkButton;
